import type { BotLevel } from '@/shared/game/types'
import type { Brain } from '../match'
import { netBrain } from './brain'
import { loadModel, type Model, type ModelFile } from './model'

/**
 * Уровни компьютера — одна сеть, разная небрежность выбора.
 *
 * Сеть на всех уровнях одна и та же и видит позицию одинаково; уровень
 * решает, насколько строго она берёт лучший по своей оценке замысел
 * (температура, см. netBrain). Слабый уровень поэтому ошибается «как
 * человек» — путает близкие по ценности ходы и лишь изредка грубо, — а не
 * ходит наугад, как прежний easy.
 *
 * Числа подобраны ареной (tools/arena.ts, 3000 партий вдвоём) под доли
 * побед против hard: normal — около трети, easy — около седьмой части.
 * Меняются вместе с моделью: у переобученной сети шкала оценок другая, и
 * с теми же числами уровни сползли бы. Серверная копия —
 * App\Domain\Ludo\Bot\Net\NetBrain::TEMPERATURE.
 */
export const TEMPERATURE: Record<BotLevel, number> = {
  easy: 0.025,
  normal: 0.012,
  hard: 0,
}

let loaded: Promise<Model> | null = null

/**
 * Модель — отдельным чанком и только по требованию: весов на три сотни
 * килобайт, а нужны они лишь в партии с компьютером на одном устройстве.
 * В сетевой партии за компьютер думает сервер.
 */
export function model(): Promise<Model> {
  loaded ??= import('./model.json').then((file) => loadModel(file.default as ModelFile))

  return loaded
}

export function levelBrain(net: Model, level: BotLevel, random: () => number): Brain {
  return netBrain(net, TEMPERATURE[level], random)
}
